import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
// import * as styles from "./ColumnsPanel.module.scss";
import { GeneralSizeKeyToPaddingNumber  } from "../../../utils/datasources"
import ClickableImage from "../../internal/clickableImage/ClickableImage";
import ModalHelper from "../../../utils/modalHelper";
import * as styles from "../columnsPanel/ColumnsPanel.module.scss"
const MultiIndustryInfograpicsPanel = ({ blok }) => {
  const { 
    column_image_buttons
  } = blok ? blok : [];
  const headerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.header_padding_top),
        headerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.header_padding_bottom),
        footerPaddingTop = GeneralSizeKeyToPaddingNumber(blok.footer_padding_top),
        footerPaddingBot = GeneralSizeKeyToPaddingNumber(blok.footer_padding_bottom)

  const colSpan = parseInt(12 / column_image_buttons.length);
  return (
    <PanelWrapper blok={blok}>
      {blok.show_header ? (
        <div className={styles.header_span} style={{paddingTop: headerPaddingTop, paddingBottom: headerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.header_text)}
          ></div>
        </div>
      ) : null}
      <Container className={styles.ThreeColImageButtonContainer}>
        <Row className={styles.rowContainer}>
        {column_image_buttons?.map((image_button) => {
          
          return(
            <Col xs={12} sm={colSpan} className={styles.colContainer}>
              {image_button.modal ? <ModalHelper buttonProps={{component: "click_image", modal: image_button.modal, image: image_button.image, btnTheme: image_button.button_theme}}/> :<ClickableImage image={image_button.image} imageLink={image_button.click_link} isModal={image_button.is_modal} modalId={image_button.modal_id} modal={image_button.modal} />}
              {image_button.modal_trigger ? <ModalHelper buttonProps={{modal: image_button.modal, triggerText: image_button.modal_trigger}}></ModalHelper> : null}
              <div className={image_button.modal_trigger ? styles.multiImageButtonContent : styles.imageButtonContent} dangerouslySetInnerHTML={resolveRichText(image_button.content)}></div>
            </Col>
          )
        })}
        </Row>
      </Container>

      {blok.show_footer ? (
        <div className={styles.footer_span} style={{paddingTop: footerPaddingTop, paddingBottom: footerPaddingBot}}>
          <div
            dangerouslySetInnerHTML={resolveRichText(blok.footer_text)}
          ></div>
        </div>
      ) : null}
    </PanelWrapper>
  );
};

export default MultiIndustryInfograpicsPanel;
